import React, { useState, useEffect, useCallback } from 'react';
import './style.scss';
import Icon from 'react-icons-kit';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { chevronLeft, plus } from 'react-icons-kit/feather';
import Requests from '../../../../utils/Requests/Index';
import LoadingComponent from '../../../../components/loading/Index';

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [item, setItem] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);

  // features state
  const [items, setItems] = useState([]);
  const [inputValue, setInputValue] = useState('');

 const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

  /* ----------------------------------
     Fetch profile data
  -----------------------------------*/
  const fetchData = useCallback(async () => {
    try {
      const data = await Requests.ExpertCounselorsProfile.Show(id, header);
      if (data) {
        setItem(data);
        setItems(Array.isArray(data.features) ? data.features : []);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [id, header]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /* ----------------------------------
     Features handlers
  -----------------------------------*/
  const addItem = () => {
    if (!inputValue.trim()) return;
    setItems([...items, inputValue]);
    setInputValue('');
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };
  // Handle image
    const handleImage = async (event) => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 800) {
                setError({ ...error, image: 'Select less than 800KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })

            let formData = new FormData()
            formData.append('image', file)
            setItem({ ...item, image: null })

            const response = await Requests.ExpertCounselorsProfile.UpdateImage(id, formData, header)
            if (response.status === true) {
                toast.success(response.message)
            }
        }
    }

  /* ----------------------------------
     Submit update
  -----------------------------------*/
  const onSubmit = async (data) => {
    try {
      setUpdating(true);

      const payload = {
        name: data.name,
        expert: data.expert,
        features: items,
        social: {
          facebook: data.facebook || '',
          instagram: data.instagram || '',
          linkedin: data.linkedin || '',
        },
      };

      await Requests.ExpertCounselorsProfile.Update(id, payload, header);
      toast.success('Profile updated successfully');
      navigate('/dashboard/website/expert-counselors-profile');
    } catch (err) {
      console.error(err);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <LoadingComponent />;

  return (
    <div className="store-blog pb-4">
      <div className="container-fluid">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white p-4 d-flex justify-content-between">
            <h6>Edit Expert Counselors Profile</h6>
            <Link
              to="/dashboard/website/expert-counselors-profile"
              className="btn shadow-none rounded-circle"
            >
              <Icon icon={chevronLeft} size={22} />
            </Link>
          </div>

          <div className="card-body p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Name */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.name && errors.name.message ? (
                            <p className="text-danger">{errors.name && errors.name.message}</p>
                        ) : <p>Name</p>
                        }

                        <input
                            type="text"
                            name="name"
                            defaultValue={item.name}
                            className="form-control shadow-none"
                            placeholder="Enter Name"
                            {...register("name",{ required: "Name is required" })}
                        />
                    </div>
                </div>

                {/* Expert */}
                <div className="col-12 col-lg-6">
                    <div className="form-group mb-4">
                        {errors.expert && errors.expert.message ? (
                            <p className="text-danger">{errors.expert && errors.expert.message}</p>
                        ) : <p>Expert</p>
                        }

                        <input
                            type="text"
                            name="expert"
                            defaultValue={item.expert}
                            className="form-control shadow-none"
                            placeholder="Enter Expert"
                            {...register("expert",{ required: "Expert is required" })}
                        />
                    </div>
                </div>
              </div>

            {/* Features */}
            <div className="form-group mb-4">
                {errors.features && errors.features.message ? (
                    <p className="text-danger">{errors.features && errors.features.message}</p>
                ) : <p>Features</p>}

                <ul className="list-group mb-3">
                    {items.map((item, index) => (
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                            {item}
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeItem(index)}
                            >
                                ✕
                            </button>
                        </li>
                    ))}
                </ul>

                <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                    <input
                        type="text"
                        placeholder="Enter Features"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{
                            flex: "1",
                            padding: "6px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                        }}
                    />
                    <div
                        onClick={addItem}
                        className='btn btn-sm btn-danger'
                    >
                        Add
                    </div>
                </div>
            </div>

            {/* Social */}
            <div className="row">
                {/* Facebook */}
                <div className="col-12 col-md-4">
                    <div className="form-group mb-4">
                        {errors.facebook && errors.facebook.message ? (
                            <p className="text-danger">{errors.facebook && errors.facebook.message}</p>
                        ) : <p>Facebook</p>
                        }

                        <input
                            type="text"
                            name="facebook"
                            className="form-control shadow-none"
                            defaultValue={item?.social?.facebook}
                            placeholder="Enter Facebook URL"
                            {...register("facebook")}
                        />
                    </div>
                </div>

                {/* instagram */}
                <div className="col-12 col-md-4">
                    <div className="form-group mb-4">
                        {errors.instagram && errors.instagram.message ? (
                            <p className="text-danger">{errors.instagram && errors.instagram.message}</p>
                        ) : <p>Instagram</p>
                        }

                        <input
                            type="text"
                            name="instagram"
                            className="form-control shadow-none"
                            placeholder="Enter Instagram URL"
                            defaultValue={item?.social?.instagram}
                            {...register("instagram")}
                        />
                    </div>
                </div>

                {/* linkedin */}
                <div className="col-12 col-md-4">
                    <div className="form-group mb-4">
                        {errors.linkedin && errors.linkedin.message ? (
                            <p className="text-danger">{errors.linkedin && errors.linkedin.message}</p>
                        ) : <p>LinkedIn</p>
                        }

                        <input
                            type="text"
                            name="linkedin"
                            className="form-control shadow-none"
                            placeholder="Enter LinkedIn URL"
                            defaultValue={item?.social?.linkedin}
                            {...register("linkedin")}
                        />
                    </div>
                </div>
            </div>

                {/* Image upload Container */}
                <div className="form-group mb-4">
                    {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                    <div className="d-flex">
                        {item && item.image ?
                            <div className="img-container text-center mr-2">
                                <div className="image border">
                                    <img src={item.image} className="img-fluid" alt="..." />
                                </div>
                            </div>
                            : selectedFile ?
                                <div className="img-container text-center mr-2">
                                    <div className="image border">
                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                    </div>
                                </div>
                                : null}

                        <div className="img-container text-center">
                            <div className="image border">
                                <input type="file" className="upload" onChange={handleImage} />
                                <div className="flex-center flex-column">
                                    <Icon icon={plus} size={22} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


              <div className="text-end mt-4">
                <button className="btn btn-primary" disabled={updating}>
                  {updating ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;


